export default __webpack_public_path__ + "static/media/formal-4.33978641.jpg";